import React, { useState, useEffect, useMemo } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { moduleGroupsManager } from 'redux/action/moduleGroups';
import { moduleManager } from 'redux/action/modules';
import { reloadPwDateFunction } from 'redux/action/login';
import { authManager } from 'redux/action/auths';
import { settingManager } from 'redux/action/settings';
import { getCriterion } from 'redux/action/criterion';
import AuthRoute from '../session/AuthRoute';
import AppHeader from './appHeader/AppHeader';
import AppFooter from './appFooter/AppFooter';
import NotFound from '../error/NotFound';
import Alert from '../alert/Alert';
import Gas from '../gas/Gas';
import Report from '../report/Report';
import EventLog from '../eventLog/EventLog';
import Config from '../config/Config';
import MainInfo from './mainInfo/MainInfo';
import MobileMain from '../mobile/MobileMain';

import { fnLogout } from 'utils/logout';
import { mobilecheck } from 'utils/mobileCheck';

import { theme } from 'theme';
import { MainContainer, Scroll } from './Main.css.js';
import alertSound from 'static/sound/warning-5s.mp3';
import MainMenu from './mainInfo/mainMenu/MainMenu';

const Main = (props) => {
  const dispatch = useDispatch();
  const [mainTitle, setMainTitle] = useState('');
  const [titlePrefix, setTitlePrefix] = useState('');
  const loginStatus = useSelector((store) => store.loginManager.status); // 로그인 데이터
  const moduleGroups = useSelector((store) => store.moduleGroups); // 장치 데이터
  const modules = useSelector((store) => store.modules); // 장치 데이터
  const criterion = useSelector((store) => store.criterion); // 각 탐지파트별 관리기준 설정
  const settings = useSelector((store) => store.settings); // 설정 데이터
  const auths = useSelector((store) => store.auths);
  const audio = useMemo(() => new Audio(alertSound));

  useEffect(() => {
    dispatch(reloadPwDateFunction());
    dispatch(authManager());
    dispatch(settingManager());
    dispatch(moduleGroupsManager(loginStatus.authIdx));
    dispatch(moduleManager(loginStatus.authIdx));
    dispatch(getCriterion());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    settings.status === 'FAIL' ||
    moduleGroups.status === 'FAIL' ||
    modules.status === 'FAIL' ||
    auths.status === 'FAIL' ||
    criterion.status === 'FAIL'
  ) {
    return null;
  }

  if (
    settings.status === 'WAITING' ||
    moduleGroups.status === 'WAITING' ||
    modules.status === 'WAITING' ||
    auths.status === 'WAITING' ||
    criterion.status === 'WAITING'
  ) {
    return (
      <MainContainer>
        <div style={{ height: '100vh' }}></div>
      </MainContainer>
    );
  }
  // else if (!theme[settings.setting.theme] || typeof theme[settings.setting.theme] === 'undefined') {
  //   alert("소프트웨어가 업데이트되어 초기화면으로 돌아갑니다.");
  //   fnLogout(dispatch, props.history);
  //   return null;
  // }

  return (
    <ThemeProvider theme={theme.rotec} version="sk-materials">
      <Scroll></Scroll>
      <MainContainer displayMenuName={'board'}>
        <Alert audio={audio} />
        <Router basename="/">
          {mobilecheck() ? (
            <AuthRoute path="/" render={(props) => <MobileMain modules={modules} auth={loginStatus.authIdx} {...props} />} />
          ) : (
            <>
              <AppHeader mainTitle={mainTitle} titlePrefix={titlePrefix} {...props} />
              <Switch>
                <AuthRoute
                  exact
                  path="/"
                  render={(props) => (
                    <MainInfo
                      moduleGroups={moduleGroups.groups}
                      modules={modules}
                      auth={loginStatus.authIdx}
                      setTitlePrefix={setTitlePrefix}
                      audio={audio}
                      displayMenuName={'board'}
                      {...props}
                    />
                  )}
                />
                <AuthRoute
                  exact
                  path="/icon"
                  render={(props) => (
                    <MainInfo
                      moduleGroups={moduleGroups.groups}
                      modules={modules}
                      auth={loginStatus.authIdx}
                      setTitlePrefix={setTitlePrefix}
                      audio={audio}
                      displayMenuName={'icon'}
                      {...props}
                    />
                  )}
                />
                <AuthRoute path="/gas" render={(props) => <Gas criterion={criterion} {...props} />} />
                <AuthRoute path="/report" render={(props) => <Report {...props} />} />
                <AuthRoute path="/eventLog" render={(props) => <EventLog {...props} />} />
                <AuthRoute path="/config" render={(props) => <Config criterion={criterion} {...props} />} />
                <Route render={NotFound} />
              </Switch>
              <MainMenu setMainTitle={setMainTitle} />
            </>
          )}
        </Router>
      </MainContainer>
    </ThemeProvider>
  );
};

export default Main;
